module.exports = __webpack_public_path__ + "static/nscc-logo-6c39d3163bd8e44440bafb342b1fd90f.png";